import { useLocaleFormatter } from '@customer/shared/hooks/useLocaleFormatter';
import { ChartColorScheme } from '../config';
import StackedBar from '../stacked-bar/StackedBar';
import styles from './PercentageBar.module.scss';

interface PercentageBarProps {
  percentage: number;
  colorScheme: ChartColorScheme;
}

export const PercentageBar = ({ percentage, colorScheme }: PercentageBarProps) => {
  const { getNumberPercentText } = useLocaleFormatter();

  return (
    <div className={styles.container}>
      <StackedBar total={1} portions={[percentage]} colorScheme={colorScheme} />
      <div className={styles.label}>{getNumberPercentText(percentage)}</div>
    </div>
  );
};

export default PercentageBar;
